// textAnalyzerWorkerHelper.js
import Worker from '../workers/asciiGenerator.worker'

class AsciiArtGeneratorWorkerHelper {
  constructor() {
    this.worker = new Worker()
  }

  generateAsciiArt({ grayScales, width, height, grayRamp }) {
    return new Promise((resolve, reject) => {
      const messageHandler = e => {
        resolve(e.data)
      }

      const errorHandler = error => {
        this.worker.removeEventListener('error', errorHandler)
        reject(error)
      }

      this.worker.addEventListener('message', messageHandler)
      this.worker.addEventListener('error', errorHandler)

      this.worker.postMessage({ grayScales, width, height, grayRamp })
    })
  }

  terminate() {
    this.worker.terminate()
  }
}

export default AsciiArtGeneratorWorkerHelper
